module.exports = __webpack_public_path__ + "img/power.44ca8345.png";